import React, { useEffect, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import { toast } from "react-toastify";
import { getData } from "../../../webService/webservice.js";
import Tippy from "tippy.js";
import "tippy.js/dist/tippy.css";
import "../../../styles/Auth/booking.css";
import { useStore } from "../../../Context/context.jsx";
import { Typography } from "@mui/material";
import StoreSingleAllStoresSelect, { ALL_STORE_OPTION } from "../../Challange/StoreSingleAllStoresSelect.jsx";
import Footer from "../Footer/Footer-page.jsx";
import AddBookingForm from "./AddBookingForm.jsx";
import {
    Modal,
    Box,
    Fade
} from "@mui/material";
function BookingCalendar({ sessionToken }) {
    const [isEditMode, setIsEditMode] = useState(false);
    const role = localStorage.getItem("role");
    const adminStoreIds = JSON.parse(localStorage.getItem("storeIds") || "[]");
    const [bookings, setBookings] = useState([]);
    const [loading, setLoading] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { selectedStoreId, setSelectedStoreId } = useStore();
    const [store, setStore] = useState(ALL_STORE_OPTION);
    // ✅ Fetch Bookings
    const fetchBookings = async () => {
        try {
            setLoading(true);
            const params = {};
            const sid = role === "SuperAdmin" || role === "SelfAdmin" ? store?.value : Array.isArray(selectedStoreId)
                ? selectedStoreId[0]
                : selectedStoreId;
            if (sid && sid.length === 24) {
                params.storeId = sid;
            }
            const response = await getData(
                "appointmentbookings/appointmentbookings", params,
                sessionToken
            );
            if (response?.status !== 200) {
                toast.error(response.message || "Failed to fetch Booking");
                return;
            }
            const resultsWrapper = response?.data?.[0];
            const bookingList = resultsWrapper?.paginatedResults || [];
            setBookings(bookingList);
            triggerRefresh();
            // totalCount and totalPages removed as they were unused in state
        } catch (error) {
            toast.error(error.message || "Failed to fetch Booking");
        } finally {
            setLoading(false);
        }
    };

    // ✅ Load bookings when component mounts
    useEffect(() => {
        fetchBookings(selectedStoreId);
    }, [selectedStoreId, store]);

    // ✅ Convert bookings into FullCalendar events
    const events = bookings.map((booking) => {
        const start = new Date(booking.timeSlot);
        const end = new Date(start);
        end.setHours(end.getHours() + 1); // default 1-hour duration

        const status = booking?.status || "Unknown";
        let backgroundColor = "#3788d8";
        // default black
        if (status === "Completed") backgroundColor = "#059669"; // green
        if (status === "Pending") backgroundColor = "#d97706"; // amber
        if (status === "Cancelled") backgroundColor = "#dc2626"; // red
        if (status === "In Progress") backgroundColor = "#2563eb"; // blue
        if (status === "Scheduled") backgroundColor = "#6366f1"; // indigo


        return {
            id: booking._id,
            title: `${booking.CustomerDetails?.[0]?.name || "Customer"}`,
            start,
            end,
            backgroundColor,
            borderColor: backgroundColor,
            textColor: "#fff",
            extendedProps: {
                status: booking.status,
                store: booking.storeDetails?.[0]?.storeName || "Unknown Store",
                remarks: booking.remarks || "No remarks",
                services: booking.ServiceDetails?.map((s, idx) => ({
                    name: s.serviceName,
                    artist: booking.EmployeeDetails?.find(e => e._id === (Array.isArray(booking.employeeId) ? booking.employeeId[idx] : booking.employeeId))?.name ||
                        booking.EmployeeDetails?.[idx]?.name || "N/A"
                })) || []
            },
        };
    });

    useEffect(() => {
        const handleStoreChange = () => {
            const storeId = selectedStoreId;
            setSelectedStoreId(storeId);
        };

        window.addEventListener("storeChanged", handleStoreChange);
        return () => window.removeEventListener("storeChanged", handleStoreChange);
    }, []);

    const [selectedBookingId, setSelectedBookingId] = useState(null);
    const [initialDate, setInitialDate] = useState("");


    // --- Load Functions for Async Selects (Matched from booking-page.jsx) ---
    const EMPTY_ARRAY = [];

    const loadStores = async (inputValue, loadedOptions, { page }) => {
        try {
            const res = await getData(
                "stores/stores",
                { page, limit: 10, search: inputValue },
                sessionToken
            );

            const results = res?.data?.results || EMPTY_ARRAY;

            const options = results.map(store => ({
                value: store._id,
                label: store.storeName
            }));

            return {
                options,
                hasMore: results.length === 10,
                additional: { page: page + 1 }
            };

        } catch (err) {
            console.error("Store Fetch Failed", err);
            return { options: [], hasMore: false };
        }
    };
    const handleOpenModal = (booking = null, date = null) => {
        if (booking) {
            setIsEditMode(true);
            setSelectedBookingId(booking._id);
            setInitialDate("");
        } else {
            setIsEditMode(false);
            setSelectedBookingId(null);
            setInitialDate(date || "");
        }
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setIsEditMode(false);
        setSelectedBookingId(null);
        setInitialDate("");
    };

    const triggerRefresh = () => {
        setRefreshKey(prev => prev + 1);
    };





    return (
        <div className="product-layout">
            <div className="product-content">
                <div className="product-main">
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '25px', flexWrap: 'wrap', gap: '20px' }}>
                        <Typography variant="h5" sx={{ fontWeight: 800, color: '#3C0008' }}>Appointments Calendar</Typography>
                        {(role === "SuperAdmin" || role === "SelfAdmin") && (
                            <div
                                onClick={(e) => e.stopPropagation()}
                                onMouseDown={(e) => e.stopPropagation()}
                                style={{ minWidth: '280px', width: '100%', maxWidth: '360px', flex: '0 1 auto', zIndex: 100 }}
                            >
                                <StoreSingleAllStoresSelect
                                    value={store}
                                    onChange={(selectedOption) => setStore(selectedOption)}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 10000 }),
                                        control: (base) => ({
                                            ...base,
                                            borderRadius: '12px',
                                            padding: '2px',
                                            border: '1px solid #e2e8f0',
                                            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
                                        })
                                    }}
                                />
                            </div>
                        )}
                    </div>

                    <div className="product-container">
                        <FullCalendar
                            key={refreshKey}
                            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                            initialView={window.innerWidth < 768 ? "timeGridDay" : "dayGridMonth"}
                            displayEventTime={false}
                            headerToolbar={window.innerWidth < 768 ? {
                                left: "prev,next",
                                center: "title",
                                right: "today"
                            } : {
                                left: "prev,next today",
                                center: "title",
                                right: "dayGridMonth,timeGridWeek,timeGridDay",
                            }}
                            events={events}
                            dateClick={(info) => {
                                handleOpenModal(null, info.dateStr);
                            }}
                            eventClick={async (info) => {
                                try {
                                    const response = await getData(
                                        `appointmentbookings/appointmentbooking/${info.event.id}`,
                                        {},
                                        sessionToken
                                    );

                                    const fullBooking = response?.data;
                                    if (fullBooking) {
                                        handleOpenModal(fullBooking);
                                    }
                                } catch (error) {
                                    console.error("Failed to fetch booking details:", error);
                                    toast.error("Unable to load booking details");
                                }
                            }}
                            height="auto"

                            eventDidMount={(info) => {
                                if (info.el._tippy) info.el._tippy.destroy();
                                const { status, store, remarks, services } = info.event.extendedProps;

                                const startTime = new Date(info.event.start).toLocaleTimeString([], {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                });

                                const endTime = new Date(info.event.end).toLocaleTimeString([], {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                });

                                let statusColor = "#64748b"; // default slate
                                if (status === "Completed") statusColor = "#059669";
                                if (status === "Pending") statusColor = "#d97706";
                                if (status === "Cancelled") statusColor = "#dc2626";
                                if (status === "In Progress") statusColor = "#2563eb";
                                if (status === "Scheduled") statusColor = "#6366f1";

                                Tippy(info.el, {
                                    content: `
                                        <div class="booking-tooltip-container">
                                            <div class="tooltip-header">
                                                <span class="tooltip-customer-name">${info.event.title}</span>
                                                <span class="tooltip-status-pill" style="color: ${statusColor}; border: 1px solid ${statusColor}40; background: ${statusColor}10">
                                                    ${status}
                                                </span>
                                            </div>
                                            <div class="tooltip-body">
                                                <div class="tooltip-row">
                                                    <span class="tooltip-label">Time</span>
                                                    <span class="tooltip-value">${startTime} - ${endTime}</span>
                                                </div>
                                                <div class="tooltip-row">
                                                    <span class="tooltip-label">Branch</span>
                                                    <span class="tooltip-value">${store}</span>
                                                </div>
                                                <div class="tooltip-services-section">
                                                    <div class="tooltip-label" style="margin-bottom: 4px;">Services & Artists</div>
                                                    ${info.event.extendedProps.services?.length > 0 ?
                                            info.event.extendedProps.services.map(s => `
                                                            <div class="tooltip-service-item">
                                                                <span class="tooltip-service-name">• ${s.name}</span>
                                                                <span class="tooltip-artist-name">(${s.artist})</span>
                                                            </div>
                                                        `).join('') : '<span class="tooltip-value">N/A</span>'
                                        }
                                                </div>
                                            </div>
                                            ${remarks && remarks !== "No remarks" ? `
                                            <div class="tooltip-footer-remarks">
                                                <span class="tooltip-label">Remarks: </span> ${remarks}
                                            </div>` : ''}
                                        </div>
                                    `,
                                    allowHTML: true,
                                    theme: "premium-tooltip",
                                    animation: 'shift-away',
                                    interactive: true,
                                    appendTo: () => document.body
                                });
                            }}
                            eventWillUnmount={(info) => {
                                if (info.el._tippy) info.el._tippy.destroy();
                            }}

                        />

                        <Modal
                            open={isModalOpen}
                            onClose={handleCloseModal}
                            closeAfterTransition
                            disableScrollLock
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <Fade in={isModalOpen}>
                                <Box
                                    sx={{
                                        width: { xs: '95%', sm: '650px' },
                                        maxHeight: '90vh',
                                        outline: 'none',
                                        borderRadius: '18px',
                                        overflowY: 'auto',
                                        overflowX: 'hidden',
                                        scrollbarWidth: 'thin',
                                        background: '#fff'
                                    }}
                                >
                                    <AddBookingForm
                                        isEditMode={isEditMode}
                                        bookingId={selectedBookingId}
                                        initialDate={initialDate}
                                        initialStoreId={selectedStoreId}
                                        onSuccess={async () => {
                                            handleCloseModal();
                                            await fetchBookings();
                                            triggerRefresh();
                                        }}
                                        onCancel={handleCloseModal}
                                    />
                                </Box>
                            </Fade>
                        </Modal>


                    </div>
                </div>

            </div>
            <Footer />
        </div >
    );
}

export default BookingCalendar;
